export default __webpack_public_path__ + "static/media/Titel_image_Werfkelder.3ccf5304.jpg";